import { AppAdminTable } from "components/AppAdminTable/AppAdminTable";
import { toDate } from "helpers/dateHelper";
import { useGetReturnsByOrgID } from "hooks/useGetReturnsByOrgID";
import { Link } from "react-router-dom";

const listConfig = [
  {
    key: "id",
    label: "ID",
    render: (item: any) => (
      <Link className="color-blue" to={`/admin/products/returns/view/${item.id}`}>
        {item.id}
      </Link>
    ),
  },
  {
    key: "createdAt",
    label: "Дата создания",
    formatter: (v: string) => toDate(v),
  },
  {
    key: "user",
    label: "Покупатель",
    render: (item: any) => `${item.user?.lastName} ${item.user?.firstName}`,
  },
  {
    key: "returnItems",
    label: "Товары",
    render: (item: any) =>
      item.returnItems
        ?.map((orderItem: any) => `${orderItem.name} - (${orderItem.quantity} шт.)`)
        .join(", "),
  },
  {
    key: "shipmentStatus",
    label: "Статус доставки",
  },
  {
    key: "refundStatus",
    label: "Статус возврата",
  },
];

export const Returns = () => {
  const orgID = localStorage.getItem("orgID");
  const { data, isLoading, error } = useGetReturnsByOrgID(orgID);

  if (isLoading) return <div>Загрузка...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <h2 className="m-b-16">Возвраты</h2>
      <AppAdminTable
        columnConfig={listConfig}
        data={data}
        loading={isLoading}
        onDelete={() => {}}
      />
    </div>
  );
};
